module.exports = __webpack_public_path__ + "static/media/client-area-overlay.6827b192.png";